import { useCallback } from 'react';
import { buildUpdateWidgetConfigurationActionCreator } from 'widgets/store/configuration/actions';
import { useDispatch } from 'store/hooks';
import { GridVisibleColumnState } from 'widgets/store/grid/visibleColumns/GridVisibleColumnState';
import { useWidgetContext } from 'widgets/WidgetContext';

export const useDispatchUpdateVisibleColumns = <TColumnId extends string>() => {
    const { widgetType, widgetKey } = useWidgetContext();
    const dispatch = useDispatch();
    const actionCreator =
        buildUpdateWidgetConfigurationActionCreator<
            GridVisibleColumnState<TColumnId>
        >(widgetType);

    return useCallback(
        (visibleColumns: TColumnId[]) => {
            dispatch(actionCreator(widgetKey, { visibleColumns }));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [widgetType, widgetKey]
    );
};
